import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { fadeInUp400ms } from '../../../../../../../@vex/animations/fade-in-up.animation';
import { stagger80ms } from '../../../../../../../@vex/animations/stagger.animation';
import { openTeamForm } from '../../screens/team-form-modal/team-action-mock-team-form-modal.component';
import { TeamActionMockTeamsStore } from '../../team-action-mock-teams.store';

// Maquette d'estimation « action d'équipe » : page Équipes du menu Paramétrage Client (données fictives).
@Component({
  selector: 'team-action-mock-teams-page',
  templateUrl: './team-action-mock-teams-page.component.html',
  animations: [fadeInUp400ms, stagger80ms],
})
export class TeamActionMockTeamsPageComponent {
  readonly teams$ = this.store.teams$;

  constructor(
    private store: TeamActionMockTeamsStore,
    private dialog: MatDialog,
  ) {}

  create(): void {
    openTeamForm(this.dialog, this.store, {}).subscribe();
  }
}
